import { PhArrowLeft, PhFileText } from '@phosphor-icons/vue'
import i18n from '@/i18n'

export const SOCIAL_SETTINGS_BACK_ICON = PhArrowLeft
export const SOCIAL_SETTINGS_NAV_GROUPS = [
  {
    get label() { return i18n.global.t('social.settingsNav.groupLabel') },
    items: [{ id: 'info', get label() { return i18n.global.t('social.settingsNav.infoLabel') }, icon: PhFileText }],
  },
]

export function socialSettingsItemRoute(contentId: string, _id = 'info'): string {
  return `/social/${contentId}/settings/info`
}

export function socialEditorRoute(contentId: string): string {
  return `/social/${contentId}`
}
